import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import classNames from 'classnames';
import React from 'react';
import { Controller } from 'react-hook-form';
import { AtomTextFieldProps } from '../../interfaces/textField/textField';
import '../textField/textField.scss';

type RHFSupportProps = AtomTextFieldProps & {
  control: any;
  name: string;
  rules?: any;
  defaultValue?: string;
};

const RHFTextField: React.FC<RHFSupportProps> = ({
  control,
  name,
  rules,
  defaultValue = '',
  helperText,
  error,
  required,
  disabled = false,
  readOnly = false,
  focused = false,
  variant = 'outlined',
  type = 'text',
  fullWidth = false,
  color = 'primary',
  multiline = false,
  maxRows = 3,
  minRows = 1,
  startAdornment,
  endAdornment,
  margin = 'normal',
  placeholder = '',
  className,
  id = '',
  label = '',
  maxLength,
  minLength,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field, fieldState }) => {
        const hasError = fieldState?.error || error;
        const helperTextData =
          typeof helperText === 'string' ? (
            <span
              className={classNames({
                'MuiFormHelperText-root Mui-error': hasError,
              })}
            >
              {fieldState?.error?.message || helperText}
            </span>
          ) : (
            <>{helperText}</>
          );

        return (
          <TextField
            {...field}
            inputRef={field.ref}
            label={label}
            type={type}
            fullWidth={fullWidth}
            multiline={multiline}
            color={hasError ? 'error' : color}
            maxRows={maxRows}
            minRows={minRows}
            helperText={helperTextData}
            error={!!hasError}
            disabled={disabled}
            margin={margin}
            required={required}
            placeholder={placeholder}
            autoComplete="off"
            className={className}
            id={id}
            inputProps={{
              maxLength: maxLength ?? undefined,
              minLength: minLength ?? undefined,
            }}
            InputProps={{
              startAdornment: startAdornment ? (
                <InputAdornment position="start">
                  {startAdornment}
                </InputAdornment>
              ) : null,
              endAdornment: endAdornment ? (
                <InputAdornment position="end">
                  {endAdornment}
                </InputAdornment>
              ) : null,
              readOnly,
            }}
          />
        );
      }}
    />
  );
};

export default RHFTextField;
